import { render, staticRenderFns } from "./AccountWithdrawalApplyListManage.vue?vue&type=template&id=981ef0c2&scoped=true"
import script from "./AccountWithdrawalApplyListManage.vue?vue&type=script&lang=js"
export * from "./AccountWithdrawalApplyListManage.vue?vue&type=script&lang=js"
import style0 from "./AccountWithdrawalApplyListManage.vue?vue&type=style&index=0&id=981ef0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981ef0c2",
  null
  
)

export default component.exports